import { TransactionSectionArea as Component } from './component';
import Connector from './connector';
import { ConnectorProps } from './TransactionSectionArea.proptype';

export interface TransactionAreaProps extends Omit<ConnectorProps, 'component'> {}

export const TransactionSectionArea = (props: TransactionAreaProps) => <Connector {...props} component={Component} />;
